<!--
  @Description Bug提交主界面
  @Date 2022-03-15
  @Author liushuo
  ------------------------
  @Description 数据处理
  @Date 2022-10-25
  @Author liufu
-->
<template>
  <div class="container">
    <homeHeader ref="HomeHeader" title="数据处理" :isShowProjectSelect="false" key="schedule"></homeHeader>
    <div class="main" v-show="isSearch">
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            :buttonVisible="buttonVisible"
            :parentData="this"
            ref="toolBarBtn"
            :moreButtonList="moreButtonList"
          ></toolBarBtn>
        </div>

        <!-- 基础设置功能区 -->
        <div class="settings-table-dv">
          <el-row :gutter="20">
            <el-col :span="24">
              <!-- 明细表格 -->
              <div class="detail-table-dv" :style="{ height: this.settingsCardHeight }">
                <!-- <BugVxeGrid
                  :tableData="tableData"
                  :tabActiveName="tabActiveName"
                  :searchFormVisible="searchFormVisible"
                  @handleDbClick="handleDbClick"
                ></BugVxeGrid> -->
                <vxe-grid
                  ref="xTable"
                  resizable
                  :data="tableData"
                  size="mini"
                  :mouse-config="{ area: true }"
                  highlight-hover-row
                  highlight-current-row
                  :height="tableHeight"
                  :columns="gridColumns"
                  :row-config="{ height: 60 }"
                  :showOverflow="true"
                  :tooltip-config="{
                    showAll: true,
                    theme: 'dark'
                  }"
                  :keyboard-config="{
                    isArrow: true,
                    isEnter: true,
                    isTab: true,
                    isClip: true,
                    enterToTab: true,
                    isEdit: true
                  }"
                  :sort-config="{
                    trigger: 'cell',
                    orders: ['desc', 'asc', null]
                  }"
                  :seq-config="{
                    startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
                  }"
                  :pager-config="tablePage"
                  @page-change="handlePageChange"
                  @cell-dblclick="handleDbClick"
                  :cell-style="tableCellStyle"
                >
                </vxe-grid>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- Bug提交 -->
    <BugEditModal ref="BugEditModal" :parentObj="this" @getList="getList" :key="Math.random()"></BugEditModal>
    <!-- 明细界面 -->
    <BugCommitDetail :parentData="this" :joinID="joinID" @SingleBack="SingleBack" v-if="!isSearch" />
  </div>
</template>

<script>
import BugEditModal from './BugEditModal'
import BugCommitDetail from './BugCommitDetail.vue'

export default {
  components: {
    BugEditModal,
    BugCommitDetail
  },
  data() {
    return {
      gridColumns: [],
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 100,
        align: 'right',
        pageSizes: [100, 200, 300, 400, 500],
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      // 当前选中行的ID
      curSelectID: -1,
      searchFormVisible: false,
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组的可见性
      buttonVisible: {
        update: false,
        add: false, // 新增按钮是否显示
        save: false, // 保存按钮是否显示
        delete: false,
        refresh: true,
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 特殊权限
      specialAuthority: {},
      // 左侧列表数据
      settingsList: [],
      // tab当前激活位置
      tabActiveName: 'tabAll',
      // 拉选区域
      areas: [],
      // 按钮组扩展按钮 { icon: xxx, name: xxx, event: xxx, visible: xxx }
      moreButtonList: [],
      // 侧边栏默认选中的值
      curSelectVersion: '',
      // 传给子组件的id
      joinID: 0,
      // 是否为search界面
      isSearch: true,
      // 选中tab
      indexValue: '',
      // 是否全量查询问题 [全量 | 过滤本人]（用于缓存当前处于何种过滤状态，在操作结束后应按原先的过滤状态进行显示）
      isSearchAll: false,
      // 多个tab的表格 key:value = tabName: {...}
      tableTabOptions: {
        tabAll: {
          label: '所有',
          tableData: []
        },
        tabUnclose: {
          label: '未关闭',
          tableData: []
        },
        tabFromMe: {
          label: '由我创建',
          tableData: []
        },
        tabToMe: {
          label: '指派给我',
          tableData: []
        },
        tabSoluteByMe: {
          label: '由我解决',
          tableData: []
        },
        tabUnSolute: {
          label: '未解决',
          tableData: []
        },
        tabCC: {
          label: '抄送给我',
          tableData: []
        }
      },
      tableData: []
    }
  },
  created() {
    this.InitColumns()
    this.getSpecial()
  },
  mounted() {
    // this.getTableData()
  },
  async activated() {
    this.initButtons()
    this.getList()
  },
  methods: {
    // 设置表格单元格样式
    tableCellStyle({ row }) {
      let style = {}

      // 提出时间
      let createTime = this.ykDateFormat('yyyy-MM-dd', row.createTime)
      // 要求完成日期
      const deadLineTime = this.ykDateFormat('yyyy-MM-dd', row.deadLineTime)
      // 解决时间
      let oldresolvedTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', row.resolvedTime)
      // 参与判断的解决时间
      let resolvedTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', row.resolvedTime)
        ? this.ykDateFormat('yyyy-MM-dd HH:mm:ss', row.resolvedTime)
        : this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())

      // 如果日期等于今天, 则判断提出日期的24h, 如果不等于就按照原来的判断
      if (createTime === deadLineTime) {
        // 今天提出的bug
        createTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', row.createTime)

        if (createTime && resolvedTime) {
          const timeDiff = this.$utils.getDateDiff(createTime, resolvedTime)
          if (timeDiff.done && this.calculate(`(${timeDiff.time}/1000/60/60)&2`) > 24) {
            style = {
              backgroundColor: '#ff4757',
              color: '#ffffff'
            }
          }
        }
      } else {
        // 转换为日期
        let resolvedDate = this.ykDateFormat('yyyy-MM-dd', resolvedTime)
        if (resolvedDate && deadLineTime) {
          const dateDiff = this.$utils.getDateDiff(deadLineTime, resolvedDate)
          if (dateDiff.done && dateDiff.time > 0) {
            style = {
              backgroundColor: '#ff4757',
              color: '#ffffff'
            }
          }
        }
      }

      // 如果有关闭日期, 且没有解决日期则不显示颜色
      if (!oldresolvedTime && this.ykDateFormat('yyyy-MM-dd', row.closedTime)) {
        style = {}
      }

      return style
    },
    // 设置列
    InitColumns() {
      this.gridColumns = [
        { type: 'seq', width: 50, fixed: 'left' },
        {
          title: '提出时间',
          width: 140,
          field: 'createTime',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '标题',
          // width: 300,
          minWidth: 280,
          field: 'title',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '产品类型',
          width: 100,
          field: 'productionType',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '模块',
          width: 150,
          field: 'groupName',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '菜单',
          width: 150,
          field: 'vuePath',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '当前指派',
          width: 120,
          field: 'assignedTo',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '问题状态',
          width: 100,
          field: 'status',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '提出人',
          width: 100,
          field: 'openedBy',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '是否需要回滚',
          width: 100,
          field: 'isNeedRollback'
        },
        {
          title: '要求完成日期',
          width: 110,
          field: 'deadLineTime',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '解决时间',
          width: 140,
          field: 'resolvedTime',
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss'],
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '关闭日期',
          width: 110,
          field: 'closedTime',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        }
      ]
    },
    // 切换分页
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.getList()
    },
    // 获取明细数据
    // getTableData() {
    //   this.tableData.push({
    //     id: 1,
    //     createTime: '2022-03-15',
    //     title: '用车申请',
    //     productionType: '铁塔',
    //     groupName: '行政',
    //     vuePath: '用车申请',
    //     assignedTo: '刘铄',
    //     status: '激活',
    //     openedBy: '沈木全'
    //   })
    // },
    // 获取特殊权限，格式如：specialAuthority:{ '权限名称':true }
    getSpecial() {
      this.Authority.special.forEach(v => {
        this.specialAuthority[v.name] = true
      })
    },
    search() {
      this.isSearchAll = !this.isSearchAll
      this.$message.success(this.isSearchAll ? '查看全部' : '查看本人')
      this.$nextTick(() => {
        this.getList()
      })
    },
    // 根据产品类型、产品版本进行数据获取
    async getList() {
      let sqlTitle = this.searchSqlTitle
      // 获取列表数据
      const { data: res } = await this.$http.post(`/Common/DPBugs/list`, {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        orderBy: 'asc',
        // default: 查看提出人或当前指派为本人的未关闭的bug
        sqlTitle: sqlTitle
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return
      }
      this.tableData = res.data.rows
      this.tablePage.total = res.data.totals
    },
    initButtons() {
      this.buttonVisible = {
        save: false, // 保存按钮是否显示
        // lock: !!this.specialAuthority.super, // 锁定按钮是否显示
        // unlock: !!this.specialAuthority.super, // 解锁按钮是否显示
        add: !!this.specialAuthority.create, // 新增按钮是否显示
        update: false, // 编辑按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: true,
        sort: false, // 排序按钮是否显示
        search: true, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      }

      this.moreButtonList = [
        // {
        //   icon: 'iconfont fjyk-daochu-03-copy',
        //   name: '导出',
        //   event: 'export',
        //   disabled: !this.Authority.edit
        // }
      ]
    },
    add() {
      this.openBugEditModal()
      // this.$message.warning('新增Bug')
    },
    refresh() {
      this.getList()
    },
    // 切换
    changeNavItem(item) {
      if (item.name === this.curSelectVersion) {
        return
      }
      this.indexValue = item.name
      this.curSelectVersion = item.name
      this.$nextTick(() => {
        this.refresh()
      })
    },
    contextMenuClickEvent() {},
    // 导出
    export() {
      this.$message.warning('导出')
      // if (this.tabActiveName === 'tabAll') {
      //   // 导出进度总览表
      //   this.$refs.xTable.exportData({
      //     type: 'xlsx',
      //     columnFilterMethod({ column }) {
      //       return (
      //         !['checkbox', 'seq'].includes(column.type) &&
      //         column.property !== 'delete'
      //       )
      //     },
      //   })
      // } else if (this.tabActiveName === 'third') {
      //   // 导出进度统计表
      //   this.$refs.xTableByPerson.exportData({
      //     type: 'xlsx',
      //     columnFilterMethod({ column }) {
      //       return (
      //         !['checkbox', 'seq'].includes(column.type) &&
      //         column.property !== 'delete'
      //       )
      //     },
      //   })
      // }
    },
    // 打开Bug填写弹窗
    openBugEditModal() {
      this.$refs.BugEditModal.isShow = !this.$refs.BugEditModal.isShow
      this.$refs.BugEditModal.operateType = 'add'
    },
    // 设置弹窗数据
    // setModalData(rowData) {
    // const data = JSON.parse(JSON.stringify(rowData))
    // this.$refs.BugEditModal.form = data
    // 当前行id
    // this.curSelectID = rowData.id
    // },
    toDetail() {
      if (!this.Authority.edit) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.joinID = 0
      this.$nextTick(() => {
        this.isSearch = false
      })
    },
    handleDbClick({ row }) {
      this.$refs.xTable.closeTooltip()
      this.joinID = row.id
      this.$nextTick(() => {
        this.isSearch = false
      })
    },
    SingleBack(IfExistModify) {
      this.isSearch = true
      if (IfExistModify) {
        this.refresh()
      }
    }
  },
  computed: {
    // 进度表高度
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      let isToolBar = true
      // 正常状态下，需要加上表格距离card上下的margin
      const topBottomMargin = 20

      return this.tableHeightComputed(tableMargin + topBottomMargin, isSearchForm, isToolBar)
    },
    // 设置表格容器的高度
    settingsCardHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin 否则只有表格的两段 margin
      let topBottomMargin = 20
      let tableMargin = isSearchForm
        ? this.heightConfig.mainMargin * 4
        : this.heightConfig.mainMargin * 2 + topBottomMargin
      let isToolBar = true
      return this.tableHeightComputed(tableMargin, isSearchForm, isToolBar)
    },
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    },
    // 是否全量查询问题的过滤条件
    searchSqlTitle() {
      if (this.isSearchAll) {
        return ''
      } else {
        return 'default'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}

.toolbar-dv {
  padding: 10px;
}

.settings-table-dv {
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
}
// 左侧名称列表
.left-settings-dv {
  width: 100%;
}
.settings-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 用户名列表
.detail-table-dv {
  width: 100%;
}

/* el-tabs 样式 */
/deep/ .el-tabs__item {
  height: 30px;
  line-height: 22px;
  padding-right: 20px;
}
/deep/ .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 15px;
}
/deep/ .el-tabs__item.is-top {
  font-size: 16px;
}
</style>
